<bs-alert-overlay></bs-alert-overlay>
@if (loggedIn) {
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
} @else {
  <bs-loading message="Redirecting..."></bs-loading>
}
